import type { Uuid } from '@sibe/utilities/common';
import { HsGraphicObject } from './graphic-object.class';
import type { HsRegularGeometry } from '../../graphic-engine-new/geometry/regular-geometry.class';
import type { HsMaterial } from '../materials/material.class';

export class HsGraphicLines extends HsGraphicObject {
  constructor(uuid: Uuid, name: string, public geometry: HsRegularGeometry, public material: HsMaterial) {
    super(uuid, name, geometry, material);
  }
}
